import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { LoadingService } from '../../loading/loading.service';
import { IntervenientesService } from 'src/app/modules/services/intervenientes/intervenientes.service';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { FormControl, Validators } from '@angular/forms';
import { catchError, debounceTime, distinctUntilChanged, filter, of, switchMap } from 'rxjs';
import { EntitiesService } from 'src/app/modules/services/entities/entities.service';

@Component({
  selector: 'app-add-intervenientes-modal',
  templateUrl: './add-intervenientes-modal.component.html',
  styleUrls: ['./add-intervenientes-modal.component.scss']
})
export class AddIntervenientesModalComponent implements OnInit {

  selectedOptionEntitie: any;
  searchControlIntervenientes  = new FormControl(null, [Validators.required]);
  filteredOptionsEntities: any[] = [];
  selectedEntitie: any;
  filteredOptions: any[] = [];
  isEditMode: boolean = false;
  constructor(
    private dialog: MatDialog,

    private _snackBar: MatSnackBar,
    private loadingService: LoadingService,

    @Inject(MAT_DIALOG_DATA) public uploadData: any,
    private intervenientesService: IntervenientesService,
    private entitiesService: EntitiesService,
    iconRegistry: MatIconRegistry,
    sanitizer: DomSanitizer,
    private dialogRef: MatDialogRef<AddIntervenientesModalComponent>,
  ) { }
  ngOnInit(): void {
    this.searchControlIntervenientes.valueChanges
      .pipe(
        debounceTime(300),
        distinctUntilChanged(),
        filter((value:any) => value),
        switchMap((value) =>
          this.entitiesService
            .getEntities(0, '', '', '', value, value)
            .pipe(catchError(() => of([])))
        )
      )
      .subscribe({
        next: (results: any) => {

          if (results?.content?.length) {
            this.filteredOptionsEntities = results.content;
          } else {
            this.filteredOptionsEntities = [];
          }

        }, error: (err: any) => {
          this.filteredOptionsEntities = [];
        }
      });
  }

  back() {
    this.dialogRef.close()
  }

  onOptionSelectedIntervenientes(event: any) {
    this.selectedOptionEntitie = event.option.value;

    this.searchControlIntervenientes.setValue(
      this.selectedOptionEntitie.razaoSocial,
      { emitEvent: false }
    );
    this.selectedEntitie = this.selectedOptionEntitie;
    this.filteredOptions = [];
  }
  onSubmit() {
    const formatedInterveniente = {
      status: false,
      idEntidade: this.selectedEntitie.id || null,
    };
    this.dialogRef.close(formatedInterveniente)
  }
}
